module.exports = __webpack_public_path__ + "static/media/FBG.f6f60fd7.png";